import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldTypeahead } from "@/components/FormFields/FormFieldTypeahead/FormFieldTypeahead";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import {
  type FormFieldComponentProps,
  type VerificationServiceProps,
  type Organization,
} from "@/lib/types/types";
import { getOrgSearchUrl } from "@/lib/ProgramTheme/programThemeGetters";

export const FirstResponderOrganizationComponent = ({
  value,
  isErrored,
  onChange,
  verificationService,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps & VerificationServiceProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("organization")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldTypeahead
      fieldId="first-responder-organization"
      value={value}
      verificationService={verificationService}
      onChange={(choice: Organization) => onChange(choice)}
      placeholder={placeholder || msg({ id: "organizationPlaceholder" })}
      label={<FormattedHTMLMessage id="organization" defaultMessage="Organization" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage
            id="errorId.invalidOrganization"
            defaultMessage="You must select an organization from the list"
          />
        )
      }
      orgSearchUrl={getOrgSearchUrl(
        verificationService.viewModel,
        verificationService.programTheme,
      )}
      showPlaceholderAndHideLabel={!!placeholder}
      isRequired
      disabled={disabled}
    />
  );
};
